import { useCallback, useState } from 'react';

// ─────────────────────────────────────────────────────────────────────────────

export const useRetryAttempts = (params: Params) => {
  const { onRetry } = params;

  // ─── State ─────────────────────────────────────────────────────────────────

  const [attemptCount, setAttemptCount] = useState(INITIAL_ATTEMPT_COUNT);

  // ─── Derived ───────────────────────────────────────────────────────────────

  const hasReachedAttemptLimit = attemptCount >= MAX_ATTEMPT_COUNT;

  // ─── Handlers ──────────────────────────────────────────────────────────────

  const retry = useCallback(() => {
    setAttemptCount((previousAttemptCount) => previousAttemptCount + 1);
    onRetry();
  }, [onRetry]);

  // ───────────────────────────────────────────────────────────────────────────

  return { attemptCount, hasReachedAttemptLimit, retry };
};

// ─── Constants ───────────────────────────────────────────────────────────────

const INITIAL_ATTEMPT_COUNT = 1;
const MAX_ATTEMPT_COUNT = 3;

// ─── Types ───────────────────────────────────────────────────────────────────

type Params = {
  onRetry: () => void;
};
